'use client';

import { useAuthenticationModal } from '@/hooks/useAuthenticationModal';
import PaginaAutenticacao from '../ModalJornadaGuiadaMinhaCarteira/components/pages/Autenticacao';
import { Overlay } from '@/components/atoms/Overlay';
import { Fragment } from 'react';

import * as S from './styles';
import useBreakpoint from '@/hooks/useBreakpoint';
import { usePageScrollAreaHook } from '../PageScrollArea/hook/usePageScrollAreaHook';
import { IconeFechar } from '@/components/atoms/Icones/IconeFechar';
import IconButton from '@/components/atoms/IconButton';
import { theme } from '@/styles/theme';

export default function ModalAutenticacao() {
  const {
    authenticationModalContextProps: { visivel },
    esconderAuthenticationModalContext,
  } = useAuthenticationModal();

  const { breakpoint } = useBreakpoint();

  const { retornarValorMargemTopo } = usePageScrollAreaHook({
    isPageScrollArea: false,
  });

  if (!visivel) return null;

  const BotaoFecharModal = (
    <div
      style={{
        position: 'absolute',
        top: theme.spacing[4],
        right: theme.spacing[4],
      }}
    >
      <IconButton
        $size={2}
        $variant="soft"
        $color="neutral"
        $highContrast={true}
        $loading={false}
        $state="default"
        $focusRing={false}
        $Icon={IconeFechar}
        $onClick={esconderAuthenticationModalContext}
      />
    </div>
  );

  return (
    <Fragment>
      <Overlay
        $distanciaTopo={retornarValorMargemTopo('home')}
        $valorSobreposicaoDosDemaisComponentes={995}
        onClick={esconderAuthenticationModalContext}
      />
      <S.Container $breakpoint={breakpoint}>
        <PaginaAutenticacao
          BotaoFecharModal={BotaoFecharModal}
          BotaoVoltarPagina={<div style={{ width: 24 }}></div>}
          iniciarFluxoCadastroAssinaturas={esconderAuthenticationModalContext}
          callbackUrl={window?.location?.href}
        />
      </S.Container>
    </Fragment>
  );
}
